import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EFeedbackType, IFeedbackState, ISendFeedbackPayload } from './types';

export const initialState: IFeedbackState = {
  isSent: false,
  show: false,
  text: '',
};

export const statePropName = 'feedback';

const feedbackSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    checkFeedbackStatus(state) {
      // No state change needed
    },
    sendFeedback: {
      reducer(state, action: PayloadAction<ISendFeedbackPayload>) {
        state.text = action.payload.text;
        state.isSent = true;
      },
      prepare(text: string, rating: EFeedbackType) {
        return { payload: { text, rating } };
      },
    },
    sendFeedbackSuccess(state) {
      state.isSent = false;
    },
    sendFeedbackFailure(state) {
      state.isSent = false;
    },
    setShowFeedbackDialog(state, action: PayloadAction<boolean>) {
      state.show = action.payload;
    },
  },
});

export const FeedbackActions = feedbackSlice.actions;
export default feedbackSlice.reducer;
